import React from "react";

const Java = () => {
  return (
    <div>
      <h1>Java</h1>
      <p>This page provides explanations, examples, and common use-cases for Java in Java.</p>
    </div>
  );
};

export default Java;
